import { render, staticRenderFns } from "./AgendaPage.vue?vue&type=template&id=93a243e8&scoped=true"
import script from "./AgendaPage.vue?vue&type=script&lang=js"
export * from "./AgendaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a243e8",
  null
  
)

export default component.exports